import { Component, OnInit } from "@angular/core";
import { ViewController } from "ionic-angular";
import { AccessControlService } from "../../../app/access-control/access-control-service";
import { CALENDER_PAGE } from "../../../app/access-control/common-permission-asks";
import { Pages } from "../../../app/access-control/permissions";
import { PermissionsResponse } from "../../../app/access-control/permissions-response";
import { NavigationService } from "../../navigation.service";

@Component({
  selector: "calendar-popover",
  templateUrl: "./calendar-popover.html",
})
export class CalendarPopoverComponent implements OnInit {
  permissionsAccess = {} as PermissionsResponse;
  private hasCalendarPagePermission: boolean;

  constructor(
    public navSvc: NavigationService,
    private viewCtrl: ViewController,
    private accessControl: AccessControlService
  ) {}

  ngOnInit(): void {
    this.accessControl.getPermission(CALENDER_PAGE).subscribe((data) => {
      this.permissionsAccess = data;
      this.checkPermissions();
    });
  }

  close() {
    this.viewCtrl.dismiss();
  }

  navigateToCalendar(calendarPage: string) {
    // NOVA-1490 follow-up: Calendar Options popover is a navigation exit point —
    // switching between My Calendar / Team Calendar / Unscheduled Visits should
    // clear patient context so the brief bar doesn't carry stale patient data.
    window.sessionStorage.removeItem("patientChartInfo");
    window.sessionStorage.removeItem("patientChartId");
    window.sessionStorage.removeItem("externalId");
    window.sessionStorage.removeItem("patChartId");
    if (this.hasCalendarPagePermission) {
      this.navSvc.goToInternalPage(calendarPage, {});
    } else {
      this.navSvc.goToInternalPage("AccessDeniedPage", {});
    }

    this.close();
  }

  checkPermissions() {
    this.hasCalendarPagePermission = this.accessControl.hasAccess(
      this.permissionsAccess,
      Pages.CalendarPage
    );
  }
}



// WEBPACK FOOTER //
// ./src/navigation/components/calendar-popover/calendar-popover.ts